import { db, auth,authObject, storage, firestore } from '@/scripts/firebase';
import firebase from 'firebase'
import { Component, Vue } from 'vue-property-decorator';
import * as Sentry from "@sentry/browser";
import moment from 'moment-timezone'
import { UserPublicProfile } from '@/scripts/datatypes';

@Component({
  filters: {
    moment(date: firebase.firestore.Timestamp , format: string ): string {
      if(! date){
        return ''
      }

      if(moment(date).isValid()){
        return moment(date).format(format)
      }

      if(! moment(date).isValid() && 'toDate' in date){
        return moment(date.toDate()).format(format)
      }

      return ''
    }
  }
})

export default class Common extends Vue {
  created() {
    //
  }

  $defaultUserRole = 'student'
  $profileThumbnailSize = '_640x640'

  $getSchoolColRef() {
    const ref = db.collection('schools/')
    return ref
  }

  $getSchoolDocRef(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = this.$getSchoolColRef().doc(`${theSchoolId}`)
    return ref
  }

  $getSchoolPublicProfileColRef() {
    const ref = db.collection('schoolPublicProfile')
    return ref
  }

  $getSchoolPublicProfileDocRef(schoolId?: string) {
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = this.$getSchoolPublicProfileColRef().doc(theSchoolId)
    return ref
  }

  $getUserPublicProfileColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('userPublicProfile')
    return ref
  }

  $getUserPublicProfileDocRef(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getUserPublicProfileColRef(schoolId).doc(theUid)
    return ref
  }

  $getUserPrivateProfileColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('userPrivateProfile')
    return ref
  }

  $getUserPrivateProfileDocRef(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getUserPrivateProfileColRef(schoolId).doc(theUid)
    return ref
  }

  $getUsersPublicProfileQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = this.$getUserPublicProfileColRef(theSchoolId).where('schoolId','==',theSchoolId).where('deleted', '==',false)
    return ref
  }

  $getUsersPrivateProfileQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = this.$getUserPrivateProfileColRef(theSchoolId).where('schoolId','==',theSchoolId)
    return ref
  }

  $getSentMessageColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('sentMessage')
    return ref
  }

  $getReceivedMessageColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('receivedMessage')
    return ref
  }

  $getUserSentMessageQuery(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getSchoolDocRef(schoolId).collection('sentMessage').where('senderUid', '==' , theUid)
    return ref
  }

  $getUserReceivedMessageQuery(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getSchoolDocRef(schoolId).collection('receivedMessage').where('receiverUids','array-contains',theUid)
    return ref
  }

  $getUserImagesRef(uid?: string, schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const theUid = (uid ? uid : this.$store.getters.uid)

    const ref = storage.ref().child(`/schools/${theSchoolId}/users/${theUid}/images/`)
    
    return ref
  }

  $getSchoolsPublicProfileQuery(schoolIds?: string[]){
    const theSchoolIds = (schoolIds ? schoolIds : Object.keys(this.$store.getters.schools))
    const ref = this.$getSchoolPublicProfileColRef().where(firestore.FieldPath.documentId(), 'in', theSchoolIds).where('deleted','==',false)
    return ref
  }

  $getClassesColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('classes')
    return ref
  }

  $getUserClassesQuery(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getClassesColRef(schoolId).where('memberUids','array-contains',theUid).where('deleted','==',false).where('disabled','==',false)
    return ref
  }

  $getGroupsColRef(schoolId?: string){
    const ref = this.$getSchoolDocRef(schoolId).collection('groups')
    return ref
  }

  $getUserGroupsQuery(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getGroupsColRef(schoolId).where('memberUids','array-contains',theUid).where('deleted','==',false).where('disabled','==',false)
    return ref
  }

  private converterToDate = {
    toFirestore(data: firebase.firestore.DocumentData): firebase.firestore.DocumentData {
      return data
    },
    fromFirestore(snapshot: firebase.firestore.QueryDocumentSnapshot, options: firebase.firestore.SnapshotOptions ): firebase.firestore.DocumentData {
      const data = snapshot.data(options);
      Object.keys(data).forEach((field) => {
        //console.log(typeof data[field])
        if(typeof data[field] === 'object' && 'toDate' in data[field]){
          data[field] = data[field].toDate()
        }
      })
      return data
    }
  }

  $getEventsColRef(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = db.collection(`schools/${theSchoolId}/events/`).withConverter(this.converterToDate)
    return ref
  }

  $getEventDocRef(eventId?: string, schoolId?: string){
    const theEventId = (eventId ? eventId : null)
    const ref = this.$getEventsColRef(schoolId).doc(`${theEventId}`)
    return ref
  }

  $getEventChangelogsColRef(eventId?: string, schoolId?: string){
    const theEventId = (eventId ? eventId : null)
    const ref = this.$getEventsColRef(schoolId).doc(`${theEventId}`).collection('changelogs')
    return ref
  }

  $getUserEventsColRef(uid?: string, schoolId?: string){
    const theUid = (uid ? uid : this.$store.getters.uid)
    const ref = this.$getEventsColRef(schoolId).where('memberUids', 'array-contains', theUid).where('postStatus', '==', 'publish')
    return ref
  }

  $restrictedAccessLevel(accessLevel?: number){
    const theAccessLevel = typeof accessLevel === 'number' ? accessLevel : this.$store.getters.accessLevel
    let rAL = 5
    if(theAccessLevel >= 5){
      rAL = 0
    }
    return rAL
  }
  
  $isStaff(accessLevel?: number) {
    //教務以上
    const theAccessLevel = typeof accessLevel === 'number' ? accessLevel : this.$store.getters.accessLevel
    return theAccessLevel >= 5; 
  }

  

  

  //

  async $addDoc(colRef: firebase.firestore.CollectionReference, data: object){
    console.log(data)
    const creationTime = firestore.FieldValue.serverTimestamp()
    const docRef = await colRef.add({
      ...data,
      author: this.$store.getters.uid,
      updateTime: creationTime,
      creationTime: creationTime
    })
    return docRef
  }

  async $updateDoc(docRef: firebase.firestore.DocumentReference, data: object){
    const creationTime = firestore.FieldValue.serverTimestamp()
    console.log(data)
    await docRef.collection('changelogs/').add({
      ...data,
      author: this.$store.getters.uid,
      updateTime: creationTime,
      creationTime: creationTime
    })
    return docRef
  }

  async $createDoc(colRef: firebase.firestore.CollectionReference, data: object){

    const docRef = colRef.doc()

    const batch = db.batch()
    const creationTime = firestore.FieldValue.serverTimestamp()

    const d = {
      author: this.$store.getters.uid,
      updateTime: creationTime,
      creationTime: creationTime
    }

    batch.set(docRef,d)
    batch.set(docRef.collection('changelogs/').doc(), {
      ...data,
      ...d
    })

    console.log({
      ...data,
      ...d
    })

    await batch.commit()
    return docRef
  }

  async $waitUntilUpdatedForDoc(docRef: firebase.firestore.DocumentReference){
    let docData: firebase.firestore.DocumentData = {}

    const now = firestore.Timestamp.now()
    await new Promise((resolve) => {
      const unsubscribe = docRef.onSnapshot((snapshot) => {
        if(snapshot.exists){
          const updateTime = snapshot.get('updateTime')
          if (updateTime && updateTime.toMillis() > now.toMillis()) {
            docData = snapshot
            unsubscribe()
            resolve(null)
          }
        }
      })
    })
    return docData
  }

  $unsubscriber(observers: (firebase.Unsubscribe | undefined)[]) {
    observers.forEach((observer: firebase.Unsubscribe | undefined) => {
      observer && observer()
    })
  }

  $getErrorCode(error: {details?: {code?: string}; code?: string}){
    const code = (error.details && error.details.code) ? error.details.code : (error.code ? error.code : '') as string
    if(code == 'permission-denied'){
      Sentry.captureException(error,(scope) => {
        scope.setUser({uid: this.$store.getters.uid});
        return scope
      })
    }
    return code as string
  }

  $getErrorMessage(code = '' , defaultMessagePath = ''){
    if(typeof code === 'string' && code !== ''){
      return this.$t(`authentication.errorCode.${code}`) as string
    }

    if(defaultMessagePath && this.$te(defaultMessagePath)){
      return this.$t(defaultMessagePath) as string
    }

    return this.$t('message.error') as string
  }

  $getErrorField(code = ''){
    if(code.indexOf('email') > -1){
      return 'email'
    }

    if(code.indexOf('password') > -1){
      return 'password'
    }

    switch(code){
      case 'auth/user-mismatch':
      case 'auth/user-disabled':
      case 'auth/user-not-found':
      return 'email'
    }
    return ''
  }

  async $reauthenticateWithEmail(email: string,password: string){
    const credential = authObject.EmailAuthProvider.credential(email,password);

    const user = auth.currentUser as firebase.User

    await user.reauthenticateWithCredential(credential)
    return user
  }

  $findTextByUserProfile(text: string,user: UserPublicProfile){
    if(user.displayName && user.displayName.indexOf(text) > -1){
      return true
    }
    if(user.firstNameYomigana && user.firstNameYomigana.indexOf(text) > -1){
      return true
    }
    if(user.lastNameYomigana && user.lastNameYomigana.indexOf(text) > -1){
      return true
    }
    if(user.firstName && user.firstName.indexOf(text) > -1){
      return true
    }
    if(user.lastName && user.lastName.indexOf(text) > -1){
      return true
    }
    return false
  }
  //https://firebase.google.com/docs/reference/js/firebase.User?hl=en#error-codes_13
/*
auth/invalid-email
Thrown if the email used is invalid.
auth/email-already-in-use
Thrown if the email is already used by another user.
auth/requires-recent-signIn
Thrown if the user's last sign-in time does not meet the security threshold. Use firebase.User.reauthenticateWithCredential to resolve. This does not apply if the user is anonymous.
*/

//https://firebase.google.com/docs/reference/js/firebase.User?hl=en#error-codes_7
/*
auth/user-mismatch
Thrown if the credential given does not correspond to the user.
auth/user-not-found
Thrown if the credential given does not correspond to any existing user.
auth/invalid-credential
Thrown if the provider's credential is not valid. This can happen if it has already expired when calling link, or if it used invalid token(s). See the Firebase documentation for your provider, and make sure you pass in the correct parameters to the credential method.
auth/invalid-email
Thrown if the email used in a firebase.auth.EmailAuthProvider.credential is invalid.
auth/wrong-password
Thrown if the password used in a firebase.auth.EmailAuthProvider.credential is not correct or when the user associated with the email does not have a password.
auth/invalid-verification-code
Thrown if the credential is a firebase.auth.PhoneAuthProvider.credential and the verification code of the credential is not valid.
auth/invalid-verification-id
Thrown if the credential is a firebase.auth.PhoneAuthProvider.credential and the verification ID of the credential is not valid.
*/
}